module.exports = __webpack_public_path__ + "8511fc7f3946d270af3bbb995bef12e1.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/small/halldor-and-thordur.jpg
// module id = 467
// module chunks = 0